export default {
  name: 'WLoading',
  props: {
    color: {
      default: 'white',
      type: String,
    },
    isFullPage: {
      default: true,
      type: Boolean,
    },
  },
};
